import { createAnnotation } from "@pages/Article/components/ArticleParagraphElements/annotation/AnnotationFactory";
import { ArticleNonParagraphProps } from "@pages/Article/components/ArticleParagraphElements/utils/types";
import { cn } from "@util/helpers";
import parse, { DOMNode, domToReact, Element } from "html-react-parser";

/**
 * Renders a pull quote element in an article.
 * This component processes the body string to extract pull quotes and applies appropriate styles and classes.
 */
const PullQuote = ({
  bodyString,
  className,
  paragraphWidth,
}: ArticleNonParagraphProps) => {
  const transformPullQuote = (
    node: DOMNode
  ): string | boolean | void | object | Element | null => {
    if (!node || node.type !== "tag") return null;

    if (node.name === "p") {
      const el = node;
      const appendObject = {
        prepend: " - ",
      };
      const className = cn(
        "font-public-sans text-sm font-light tracking-2% text-gray-850 lg:text-xl"
      );

      const annotation = createAnnotation({ className, appendObject });

      return <>{annotation(el)}</>;
    }

    if (node.name === "blockquote") {
      const el = node;
      const children = el.children as DOMNode[];
      const className =
        "mb-4 font-notoSerif text-7xl font-light tracking-2% text-gray-850 lg:text-11xl";

      const appendObject = {
        prepend: "“",
        append: "”",
      };

      const annoation = createAnnotation({ className, appendObject });

      return (
        <blockquote
          className="mb-4 whitespace-normal font-notoSerif text-7xl font-light tracking-2% text-gray-850 lg:text-11xl"
          data-testid="pull-quote-component-quote"
        >
          {domToReact(children, {
            replace: annoation,
          })}
        </blockquote>
      );
    }

    return null;
  };

  const transformPullQuoteBody = (
    node: DOMNode
  ): string | boolean | void | object | Element | null => {
    if (!node || node.type !== "tag") return null;

    if (
      node.name === "div" &&
      node.attribs.class.includes("paragraph--type-sidebar-quotebox")
    ) {
      const el = node;
      const children = el.children as DOMNode[];

      return (
        <div
          data-testid="article-pull-quote-component"
          className={cn(className, paragraphWidth)}
        >
          {domToReact(children, {
            replace: transformPullQuote,
          })}
        </div>
      );
    }
  };

  return (
    <>
      {parse(bodyString, {
        replace: transformPullQuoteBody,
      })}
    </>
  );
};

export default PullQuote;
